// Postventa criticidad S1–S4 (taxonomía v2). The visible LABEL comes
// from the shared module (`CRITICIDAD_LABEL` in @bitacorapro/api-types,
// the same one the PWA reads); the hints are dashboard-only help copy.
// The legacy fallback maps the facility-era `severity` strings that
// older observations still carry — also from the shared module.
// `sevLabel` / `sevPillClass` in ../util.ts stay untouched — facility
// renders through them.

import { LEGACY_SEVERITY_TO_DERIVED } from "@bitacorapro/api-types";

export type SeverityCode = "S1" | "S2" | "S3" | "S4";

export const SEVERITY_HINT: Record<SeverityCode, string> = {
  S1: "Riesgo a personas, riesgo estructural o recinto inutilizable.",
  S2: "Compromete la función o la estanqueidad, o el daño progresa.",
  S3: "Daño funcional leve: el elemento no opera como fue especificado.",
  S4: "Opera bien, sólo afecta la terminación.",
};

export const LEGACY_FALLBACK: Readonly<Record<string, SeverityCode>> = LEGACY_SEVERITY_TO_DERIVED;

export function resolveSeverityCode(o: {
  effectiveSeverity?: SeverityCode | null | undefined;
  derivedSeverity?: SeverityCode | null | undefined;
  severity?: string | null | undefined;
}): SeverityCode | null {
  return (
    o.effectiveSeverity ??
    o.derivedSeverity ??
    (o.severity && Object.hasOwn(LEGACY_FALLBACK, o.severity)
      ? (LEGACY_FALLBACK[o.severity] ?? null)
      : null)
  );
}
